import React, { useState, useEffect, useContext } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { Button, Checkbox } from 'quantux-ui';
import CaseScheduleContext from './case-schedule-context';
import { blue } from '../../theme';

const BELL_ICON = (
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 7.439v4.376l2 1.75v.875H9.988C9.878 15.314 9.026 16 8 16c-1.036 0-1.88-.686-1.988-1.56H0v-.875l2-1.75V7.439c0-2.696 1.63-4.936 4.5-5.531v-.595C6.5.586 7.17 0 8 0s1.5.586 1.5 1.313v.595c2.86.595 4.5 2.844 4.5 5.53Z"
      fill="#FF6060"
    />
  </svg>
);

const WARNING_ICON = (
  <svg
    width="21"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.162 14.366a1 1 0 0 0 .84 1.543h18a1 1 0 0 0 .839-1.543l-9-13.91a1 1 0 0 0-1.68 0L.163 14.367Zm11.084-.787a1.245 1.245 0 1 1-2.49 0 1.245 1.245 0 0 1 2.49 0Zm-1.245-2.342c.688 0 1.245-.558 1.245-1.245V5.01a1.245 1.245 0 0 0-2.49 0v4.982c0 .687.557 1.245 1.245 1.245Z"
      fill="#FF0"
    />
  </svg>
);

const SUCCESS_ICON = (
  <svg
    width="12"
    height="12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 6a6 6 0 1 1 12 0A6 6 0 1 1 0 6Zm2.646-.238 1.896 1.796L9.36 3l.641.608-5.458 5.17L2 6.369l.646-.607Z"
      fill="#00B080"
    />
  </svg>
);

const AddPayer = (props) => {
  const [isNone, setIsNone] = useState(false);
  const { message } = props;

  let readOnlyMode = false;
  const context = useContext(CaseScheduleContext);
  if (context) {
    readOnlyMode = context.readOnlyMode;
  }

  useEffect(() => {
    setIsNone(props.isNonePayer)
  }, [props.isNonePayer]);

  const styles = StyleSheet.create({
    addPayerHeader: {
      height: '24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    btnIcon: {
      fill: blue[800],
      ':not(.disabled):hover': {
        fill: blue[100]
      }
    }
  });

  const handleOnChangeIsNone = () => {
    if (!readOnlyMode) {
      props.onChangeIsNonePayer(!isNone);
    }
  };

  return (
    <div>
      <div className={css(styles.addPayerHeader)}>
        <div className='fx fx__v-center'>
          {!isNone ? BELL_ICON : SUCCESS_ICON}
          &nbsp;&nbsp;
          {message}
        </div>
        <Checkbox
          text='None'
          isChecked={isNone}
          onChange={handleOnChangeIsNone}
        />
      </div>
      <Button
        btnType='primary'
        isDisabled={isNone || readOnlyMode}
        onClick={props.onAddPayer}
        style={{
          width: `${props.width}px`,
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        className={`mt-2 ${isNone ? 'disabled' : ''} ${css(styles.btnIcon)}`}
      >
        Add Payer
      </Button>
    </div>
  );
};

AddPayer.defaultProps = {
  width: 358
};
export default AddPayer;
